import { render, staticRenderFns } from "./wxpay.vue?vue&type=template&id=0689425c&"
import script from "./wxpay.vue?vue&type=script&lang=js&"
export * from "./wxpay.vue?vue&type=script&lang=js&"
import style0 from "./wxpay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports